import {Component, Inject, Input, OnInit, ViewChild} from '@angular/core';
import {FormValidatorUtil, VALID_NAME_FORM_REGEX} from '../../common/form-validator.util';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {SiteURL, SiteURLUtils} from '../../common/site.url.utils';
import {IAppConfig} from '../../store/interfaces/IAppConfig';
import {APP_CONFIG} from '../../api/config/app.config';

const CONFIRMATION_NUMBER_FIELD = 'supplierConfirmationNumber';
const LAST_NAME_FIELD = 'guestLastName';

@Component({
  selector: 'car-reservation-search',
  templateUrl: './car-reservation-search.component.html',
  styleUrls: ['./car-reservation-search.component.scss']
})
export class CarReservationSearchComponent implements OnInit {
  @Input() messages;

  formUrl: string;
  form: FormGroup;

  constructor(@Inject(APP_CONFIG) private appConfig: IAppConfig) {
  }

  ngOnInit() {
    this.formUrl = SiteURLUtils.getLocalizedSiteUrl(this.appConfig, SiteURL.TRIP_EXTRAS);
    this.form = new FormGroup({
      supplierConfirmationNumber: new FormControl('', [Validators.required]),
      guestLastName: new FormControl('', [Validators.required, Validators.pattern(VALID_NAME_FORM_REGEX)])
    }, {validators: FormValidatorUtil.checkBothRequired(CONFIRMATION_NUMBER_FIELD, LAST_NAME_FIELD)});
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/car-reservation-search/car-reservation-search.component.ts